import { matchPath } from 'react-router';
import { CHARITY_PATH } from 'src/core/paths/paths';

const STORAGE_KEY = 'charity.openedCharityId';

let openedCharityId: string | null = null;

const isCharityId = (value: string | null | undefined): value is string =>
  !!value && /^\d+$/.test(value);

const readStoredCharityId = (): string | null => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return isCharityId(stored) ? stored : null;
  } catch {
    return null;
  }
};

/** Keeps the charity a TGTG admin opened from Ninja via /charities/:charityId for the tab session. */
export const captureOpenedCharityId = (): void => {
  const fromPath = matchPath(CHARITY_PATH, window.location.pathname)?.params.charityId;
  if (!isCharityId(fromPath)) {
    openedCharityId = readStoredCharityId();
    return;
  }
  openedCharityId = fromPath;
  try {
    sessionStorage.setItem(STORAGE_KEY, fromPath);
  } catch {
    // the id stays in memory for this page load when storage is unavailable
  }
};

export const getOpenedCharityId = (): string | null => openedCharityId;

export const clearOpenedCharityId = (): void => {
  openedCharityId = null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Do nothing
  }
};
